import { React, PT, withRouter } from '@gasbuddy/react';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import BN from 'bignumber.js';

const BaseCreditTable = ({ credits, history }) => (
  <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width={3} textAlign="center">Date</Table.HeaderCell>
        <Table.HeaderCell width={2} textAlign="center">Type</Table.HeaderCell>
        <Table.HeaderCell textAlign="center">Reason</Table.HeaderCell>
        <Table.HeaderCell>Memo</Table.HeaderCell>
        <Table.HeaderCell width={3} textAlign="right">Amount</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {(credits || []).map(t => (
        <Table.Row
          key={t.id}
          onClick={() => {
            history.push(`/payments/transaction/${t.transaction_id}`);
          }}
        >
          <Table.Cell textAlign="center" style={{ paddingLeft: '3px' }}>{moment(t.created).format('M/DD/YY HH:mm')}</Table.Cell>
          <Table.Cell textAlign="center">{t.transaction_type}</Table.Cell>
          <Table.Cell textAlign="center">{t.reason_code}</Table.Cell>
          <Table.Cell>
            {t.memo}
            {' '}
            {t.transaction_id ? `Transaction #${t.transaction_id}` : ''}
          </Table.Cell>
          <Table.Cell textAlign="right">{t.amount ? `$${new BN(t.amount).toFixed(2)}` : 'n/a'}</Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

BaseCreditTable.propTypes = {
  credits: PT.arrayOf(PT.shape({
    id: PT.number.isRequired,
    transaction_type: PT.string.isRequired,
    reason_code: PT.string.isRequired,
    created: PT.string.isRequired,
    amount: PT.string.isRequired,
  })),
  history: PT.shape({ push: PT.func }).isRequired,
};

BaseCreditTable.defaultProps = { credits: [] };

export const CreditTable = withRouter(BaseCreditTable);
